export const ValidationMessages = {
  imageFormatValidation: "Please enter the image in either JPEG or PNG format.",
  imageSizeValidation: "Please make sure the image size should be less than 5MB.",
  imageRequiredValidationAd: "Please upload an ad image",
  imageRequiredValidationArticle: "Please upload an article image"
}


